import { createFileRoute } from '@tanstack/react-router'
import { HealthRecordPage } from '_/features/pets/ui/pages/health-record-page'

const HealthRecordRoute = () => {
	const { petId } = Route.useParams()
	return <HealthRecordPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/health')({
	staticData: { title: 'health_record_title' },
	component: HealthRecordRoute,
})
